import AppHeader from "@/components/AppHeader";
import dayjs from "dayjs";

export default {
  name: "company-notice-edit",
  components: {
    AppHeader
  },
  async created() {
    await this.getCompanyNotice();
    await this.getCompany();
    this.getTodayDate();
  },
  data() {
    return {
      canChoiceYears: [],
      dayCount: "",
      endDayCount: "",
      startYear: "",
      startMonth: "",
      startDay: "",
      endYear: "",
      endMonth: "",
      endDay: "",
      destination: {
        company_id: "",
        department_id: "",
        user_id: ""
      },
      notice: {
        title: "",
        url_content: ""
      },
      errorInfo: "",
      companies: [],
      departments: [],
      users: [],
      company_notice_id: ""
    };
  },
  computed: {
    startDateFormat() {
      return dayjs(
        `${this.startYear}-${this.startMonth}-${this.startDay}`
      ).format("YYYY-MM-DD");
    },
    endDateFormat() {
      return dayjs(`${this.endYear}-${this.endMonth}-${this.endDay}`).format(
        "YYYY-MM-DD"
      );
    },
    dateBefore() {
      if (
        this.startYear &&
        this.startMonth &&
        this.startDay &&
        this.endYear &&
        this.endMonth &&
        this.endDay
      ) {
        if (this.startDateFormat <= this.endDateFormat) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    startDateBeforeToday() {
      if (this.startYear && this.startMonth && this.startDay) {
        if (this.startDateFormat <= dayjs().format("YYYY-MM-DD")) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  },
  methods: {
    getTodayDate() {
      let today = new Date();
      let currentYear = today.getFullYear();
      for (let i = 0; i < 60; i++) {
        this.canChoiceYears.push(currentYear - i);
      }
      this.dayCount = new Date(this.startMonth, this.startDay, 0).getDate();
      this.endDayCount = new Date(this.endMonth, this.endDay, 0).getDate();
    },
    async getCompanyNotice() {
      let data = {};
      let res = await this.$store
        .dispatch("SHOW_COMPANY_NOTICE", {
          id: this.$route.params.company_notice_id,
          data: data
        })
        .catch(err => {
          console.log(err);
          return;
        });
      this.company_notice_id = res.company_notices.company_notice_id;
      this.destination.company_id = res.company_notices.to_company_id;
      this.getDepartments();
      this.destination.department_id = res.company_notices.to_department_id;
      this.generalGetUser();
      this.destination.user_id = res.company_notices.to_user_id;

      this.startYear = parseInt(res.company_notices.start_date.substr(0, 4));
      this.startMonth = parseInt(res.company_notices.start_date.substr(5, 2));
      this.startDay = parseInt(res.company_notices.start_date.substr(8, 2));

      this.endYear = parseInt(res.company_notices.end_date.substr(0, 4));
      this.endMonth = parseInt(res.company_notices.end_date.substr(5, 2));
      this.endDay = parseInt(res.company_notices.end_date.substr(8, 2));

      this.notice.title = res.company_notices.title;
      this.notice.url_content = res.company_notices.url_content;
    },
    async getCompany() {
      let data = {};
      let res = await this.$store
        .dispatch("GET_COMPANY", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.companies = res.companies;
    },
    async getDepartments() {
      this.destination.department_id = "";
      this.destination.user_id = "";
      let data = {
        company_id: this.destination.company_id
      };
      let res = await this.$store
        .dispatch("GET_DEPARTMENT", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.departments = res.departments;
    },
    async generalGetUser() {
      this.destination.user_id = "";
      let data = {
        company_id: this.destination.company_id,
        department_id: this.destination.department_id
      };
      let res = await this.$store
        .dispatch("GENERAL_GET_USER", { data: data })
        .catch(err => {
          console.log(err);
          return;
        });
      this.users = res.users;
    },
    async editCompanyNotice() {
      this.notice.start_date = this.startDateFormat;
      this.notice.end_date = this.endDateFormat;
      let data = {
        notice: this.notice,
        destination: this.destination
      };
      let res = await this.$store
        .dispatch("EDIT_COMPANY_NOTICE", {
          id: this.company_notice_id,
          data: data
        })
        .catch(err => {
          console.log(err);
          return;
        });
      if (res.error) {
        this.errorInfo = res.error;
      } else {
        this.goCompanyNotice();
      }
    },
    getDayCount() {
      this.startDay = "";
      this.dayCount = new Date(this.startYear, this.startMonth, 0).getDate();
    },
    getEndDayCount() {
      this.endDay = "";
      this.endDayCount = new Date(this.endYear, this.endMonth, 0).getDate();
    },
    goCompanyNotice() {
      this.$router.push({ path: "/company_notice" });
    }
  }
};
